'use client';
import { useState } from 'react';
import axios from 'axios';

export default function BulkUpload() {
  const [file, setFile] = useState(null);
  const [colleges, setColleges] = useState([]);
  const [progress, setProgress] = useState(0);
  const [status, setStatus] = useState('');
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false); // ✅ new state

  const CHUNK_SIZE = 100;

  // Step 1: Read file & show preview
  const handleFileChange = async (e) => {
    const selectedFile = e.target.files[0];
    setFile(selectedFile);
    setColleges([]);
    setProgress(0);
    setStatus('');
    setResult(null);

    if (!selectedFile) return;

    try {
      const text = await selectedFile.text();
      const cleanText = text.replace(/^\uFEFF/, '');
      const data = JSON.parse(cleanText);

      if (!Array.isArray(data)) {
        alert('JSON file must be an array of colleges');
        return;
      }

      setColleges(data);
    } catch (err) {
      console.error(err);
      alert('Failed to parse JSON file. Make sure it is valid JSON.');
    }
  };

  // Step 2: Upload in chunks
  const handleUpload = async () => {
    if (!colleges.length) return alert('No colleges to upload');

    setLoading(true); // ✅ show loading
    setStatus('Uploading...');
    const totalChunks = Math.ceil(colleges.length / CHUNK_SIZE);
    let inserted = 0, updated = 0, skipped = 0;

    for (let i = 0; i < totalChunks; i++) {
      const chunk = colleges.slice(i * CHUNK_SIZE, (i + 1) * CHUNK_SIZE);
      setStatus(`Uploading chunk ${i + 1} of ${totalChunks}...`);

      try {
        const res = await axios.post(
          'http://localhost:5000/api/admin/bulk/create_collegespage',
          { colleges: chunk },
          { headers: { 'Content-Type': 'application/json' } }
        );
        setResult(res.data)
        console.log(result)
        inserted += res.data.insertedCount || 0;
        updated += res.data.updatedCount || 0;
        skipped += res.data.skippedCount || 0;

        setProgress(Math.round(((i + 1) / totalChunks) * 100));
      } catch (err) {
        console.error('Chunk upload failed', err);
        alert(`Chunk ${i + 1} upload failed`);
      }
    }

    setStatus('Upload completed');
    
    setLoading(false); // ✅ hide loading
    setColleges([]); // ✅ clear preview
    setFile(null);    // ✅ clear file input
    setProgress(100);
  };

  return (
    <div className="p-6 max-w-4xl mx-auto bg-white shadow rounded-md">
      <h2 className="text-xl font-bold mb-4">Bulk Upload Colleges</h2>

      {!loading && !result && (
        <>
          <input
            type="file"
            accept=".json"
            onChange={handleFileChange}
            className="mb-4"
          />

          {colleges.length > 0 && (
            <div className="mb-4">
              <h3 className="font-semibold mb-2">Preview Colleges ({colleges.length})</h3>
              <div className="max-h-64 overflow-y-auto border p-2 rounded bg-gray-50">
                <table className="w-full text-left text-sm border-collapse">
                  <thead>
                    <tr>
                      <th className="border px-2 py-1">College Name</th>
                      <th className="border px-2 py-1">State</th>
                      <th className="border px-2 py-1">City</th>
                      <th className="border px-2 py-1">Courses</th>
                    </tr>
                  </thead>
                  <tbody>
                    {colleges.map((c, idx) => (
                      <tr key={idx}>
                        <td className="border px-2 py-1">{c.college_name}</td>
                        <td className="border px-2 py-1">{c.state}</td>
                        <td className="border px-2 py-1">{c.college_city}</td>
                        <td className="border px-2 py-1">
                          {Array.isArray(c.coursesDetails)
                            ? c.coursesDetails.map(cd => cd.courses).join(', ')
                            : ''}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <button
                onClick={handleUpload}
                className="mt-4 px-4 py-2 bg-emerald-600 text-white rounded hover:bg-emerald-700 transition"
              >
                Upload
              </button>
            </div>
          )}
        </>
      )}

      {loading && <p className="mt-2 font-semibold text-blue-600">Loading... Please wait!</p>}

      {progress > 0 && (
        <div className="w-full bg-gray-200 h-4 rounded mt-2">
          <div
            className="bg-emerald-600 h-4 rounded"
            style={{ width: `${progress}%` }}
          />
        </div>
      )}
    {result && (
    <div className="mt-4 bg-gray-100 p-4 rounded">
        <h3 className="font-semibold mb-2">Upload Result</h3>

        <p className="font-semibold">Inserted: {result.insertedCount}</p>
        <div className="pl-2">
        {(Array.isArray(result.inserted) ? result.inserted : []).map((item, index) => (
            <div key={index}>{item?.collegeName}</div>
        ))}
        </div>

        <p className="font-semibold mt-2">Updated: {result.updatedCount}</p>
        <div className="pl-2">
        {(Array.isArray(result.updated) ? result.updated : []).map((item, index) => (
            <div key={index}>{item?.collegeName}</div>
        ))}
        </div>

        <p className="font-semibold mt-2">Skipped: {result.skippedCount}</p>
        <div className="pl-2">
        {(Array.isArray(result.skipped) ? result.skipped : []).map((item, index) => (
            <div key={index}>
            {item?.collegeName} - <span className="text-red-600">{item?.reason}</span>
            </div>
        ))}
        </div>
    </div>
    )}


    </div>
  );
}
